import { calcItemSubtotal, resolveDiscount } from '@florezjaramillo/florezjaramillo-core'
import type { ServiceItemType } from '~/services/serviceCatalog.service'

/** El descuento se pacta en dinero o en porcentaje; se guarda tal cual se escribió. */
export type DiscountTypeType = 'amount' | 'percent'

/** Una línea editable de una cotización o cuenta de cobro. */
export interface LineType {
  description: string
  quantity: number
  unitPrice: number
  discount: number
  discountType: DiscountTypeType
  notes: string
}

export const emptyLine = (): LineType => ({ description: '', quantity: 1, unitPrice: 0, discount: 0, discountType: 'amount', notes: '' })

export const lineGross = (line: LineType) => (Number(line.quantity) || 0) * (Number(line.unitPrice) || 0)

/** Descuento en dinero de una línea: misma regla que el backend (core). */
export const lineDiscount = (line: LineType) => resolveDiscount(lineGross(line), line.discount, line.discountType)

/** Importe de una línea tras su descuento: misma regla que el backend (core). */
export const lineSubtotal = (line: LineType) => calcItemSubtotal(line)

/** Extrae un string legible de un ítem de details (puede venir como string u objeto). */
const detailToString = (d: unknown): string => {
  if (typeof d === 'string') return d
  if (d && typeof d === 'object') {
    const obj = d as Record<string, unknown>
    return String(obj.label ?? obj.value ?? obj.title ?? obj.name ?? JSON.stringify(d))
  }
  return String(d ?? '')
}

/** Una línea a partir de un servicio del catálogo, con sus entregables como detalle. */
export const lineFromService = (service: ServiceItemType): LineType => ({
  description: service.details.length ? `${service.name}\n${service.details.map(d => `• ${detailToString(d)}`).join('\n')}` : service.name,
  quantity: 1,
  unitPrice: service.price,
  discount: 0,
  discountType: 'amount',
  notes: service.description
})
